import { Space } from "@store/space/types";
import { User } from "@store/user/types";
import { IssueType } from "@store/issue/types";
import { EntityId } from "@reduxjs/toolkit";
import { Attachment } from "@/types/common";

const weekdays = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"] as const;
export type Weekdays = (typeof weekdays)[number];
export const months = [
  "jan",
  "feb",
  "mar",
  "apr",
  "may",
  "jun",
  "jul",
  "aug",
  "sep",
  "oct",
  "nov",
  "dec",
] as const;
export type Month = (typeof months)[number];

export type RecurringIssueFilter = {
  issueType?: IssueType;
  period?: string;
  search?: string;
};

export interface RecurringIssue {
  attachment?: Attachment;
  attachmentUrl?: string;
  hktdAttachmentId?: string;
  id: EntityId;
  label: string;
  description?: string;
  startDate: Date;
  endDate: Date | null;
  nextCreationDate: Date;
  spaceIds: Space["id"][];
  createdBy: User["id"];
  reportedBy: string;
  issueType: IssueType;
  interval: number;
  createOnCompletion: boolean;
  frequency: Frequencies | "manual";
}

export interface CreateRecurringIssueParams
  extends Omit<
    RecurringIssue,
    | "id"
    | "nextCreationDate"
    | "spaceIds"
    | "startDate"
    | "createOnCompletion"
    | "endDate"
    | "attachment"
    | "hktdAttachmentId"
  > {
  hktdSpaceIds: Space["id"][];
  startDate: string;
  endDate: string | null;
  hktdAttachmentId?: string;
}

export enum Frequencies {
  Daily = "daily",
  Weekly = "weekly",
  Monthly = "monthly",
  Yearly = "yearly",
}
